import React from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminSettings = () => {
  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">⚙️ Тохиргоо</h1>
        </div>

        <div className="admin-main">
          <div style={{ textAlign: 'center', padding: '40px', color: '#ddd' }}>
            <p style={{ fontSize: '18px', marginBottom: '15px' }}>⏳ Энэ хэсэг ирээдүйд хөгжүүлэх гэж байна</p>
            <p style={{ fontSize: '14px', color: '#999' }}>Систем тохиргоо удирдах функцийн хөгжүүлэлт эхэлнэ</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;

/*
// ORIGINAL CODE - COMMENTED OUT FOR FUTURE USE
import React, { useState } from 'react';
import AdminSidebar from '../components/AdminSidebar';
import '../styles/admin.css';

const AdminSettings = () => {
  const [settings, setSettings] = useState({
    siteName: 'Optimize Inc',
    siteDescription: 'Аж үйлдвэрийн шийдлүүдийн салбар',
    siteEmail: 'info@optimize-inc.com',
    sitePhone: '+976-9869-8117272',
    maintenanceMode: false,
    analyticsEnabled: true,
  });

  const [saved, setSaved] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSaveSettings = (e) => {
    e.preventDefault();
    // Save to API or localStorage
    localStorage.setItem('siteSettings', JSON.stringify(settings));
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="admin-container">
      <AdminSidebar />
      <div className="admin-content">
        <div className="admin-header">
          <h1 className="admin-header-title">⚙️ Тохиргоо</h1>
        </div>

        <div className="admin-main">
          {saved && (
            <div className="alert alert-success">
              <span>✓</span>
              <span>Тохиргооны өөрчлөлт амжилттай хадгалагдлаа!</span>
            </div>
          )}

          <form onSubmit={handleSaveSettings} className="admin-form">
            <h3 style={{ color: '#fff', marginBottom: '20px' }}>🔧 Сайтын Үндсэн Тохиргоо</h3>

            <div className="form-group">
              <label>Сайтын Нэр</label>
              <input
                type="text"
                name="siteName"
                value={settings.siteName}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Сайтын Тайлбар</label>
              <textarea
                name="siteDescription"
                value={settings.siteDescription}
                onChange={handleInputChange}
                required
              ></textarea>
            </div>

            <div className="form-group">
              <label>Сайтын Имэйл</label>
              <input
                type="email"
                name="siteEmail"
                value={settings.siteEmail}
                onChange={handleInputChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Сайтын Утас</label>
              <input
                type="tel"
                name="sitePhone"
                value={settings.sitePhone}
                onChange={handleInputChange}
                required
              />
            </div>

            <div style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid rgba(255, 255, 255, 0.1)' }}>
              <h3 style={{ color: '#fff', marginBottom: '20px' }}>🛠️ Нэмэлт Сонголтууд</h3>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="maintenance"
                  name="maintenanceMode"
                  checked={settings.maintenanceMode}
                  onChange={handleInputChange}
                  style={{ width: 'auto', cursor: 'pointer' }}
                />
                <label htmlFor="maintenance" style={{ margin: 0, cursor: 'pointer' }}>
                  Үйлчилгээ үзүүлэлтийн горим (Сайт хаалттай байх)
                </label>
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <input
                  type="checkbox"
                  id="analytics"
                  name="analyticsEnabled"
                  checked={settings.analyticsEnabled}
                  onChange={handleInputChange}
                  style={{ width: 'auto', cursor: 'pointer' }}
                />
                <label htmlFor="analytics" style={{ margin: 0, cursor: 'pointer' }}>
                  Аналитикийг идэвхжүүлэх
                </label>
              </div>
            </div>

            <div className="admin-btn-group" style={{ marginTop: '30px' }}>
              <button type="submit" className="admin-btn admin-btn-primary">
                💾 Хадгалах
              </button>
              <button
                type="reset"
                className="admin-btn admin-btn-secondary"
                onClick={() => window.location.reload()}
              >
                🔄 Сэргээх
              </button>
            </div>
          </form>

          <div style={{ marginTop: '40px', padding: '20px', background: 'rgba(53, 51, 51, 0.5)', borderRadius: '8px' }}>
            <h3 style={{ color: '#fff', marginBottom: '15px' }}>ℹ️ Систем Мэдээлэл</h3>
            <p><strong style={{ color: '#F45325' }}>React хувилбар:</strong> 18.0.0</p>
            <p><strong style={{ color: '#F45325' }}>Admin API:</strong> v1.0</p>
            <p><strong style={{ color: '#F45325' }}>Сүүлийн үнэлэмжийг хийсэн огноо:</strong> {new Date().toLocaleDateString()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminSettings;
*/
